import Cookies from 'js-cookie';

//Para cada módulo crear un archivo con las requests necesarias, para exportarlas y llamarlas desde el componente correspondiente

export function saveAuthData(data, email){
    let accessToken = data.accessToken;
    let refreshToken = data.refreshToken;

    localStorage.setItem("email", email);
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
}

export function checkAuth(){
    let accessToken = localStorage.getItem("accessToken");
    let refreshToken = localStorage.getItem("refreshToken");
    
    return accessToken != undefined;
}

export function logOut(router){
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("email");
    router.push({ path: "/login" })
}